if (!customElements.get('video-wrapper')) {
  customElements.define(
    'video-wrapper',
    class VideoWrapper extends HTMLElement {
      connectedCallback() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.addEventListener('canplay', () => entry.target.play().catch(() => {}), { once: true });
                entry.target.load();
              } else {
                entry.target.pause();
              }
            });
          },
          { threshold: 0.25 }
        );

        this.querySelectorAll('.video-bg__media video.loaded').forEach((video) => {
          this.observer.observe(video);
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
